import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/luckiest-guy";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/800.css";
import "@fontsource/nunito/900.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/frames.css";
import "./styles/motion.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
